import React, { useEffect, useState } from "react";
import { BadgesModalContainer, Modal } from "../../../styled/setting";
import { toast } from "react-toastify";
import { IoClose } from "react-icons/io5";

const BadgesModal = ({ badges, formData, setModal, setFormData }) => {
  const [checked, setChecked] = useState([]);

  console.log(formData);

  useEffect(() => {
    setChecked(formData.cmpnyBadge || []);
  }, [formData.cmpnyBadge]);

  const toggleCheck = (id) => {
    if (checked.includes(id)) {
      setChecked((data) => [...data].filter((checked) => id !== checked));
    } else {
      if (checked.length > 1) {
        toast.error("최대 2개까지 선택 가능합니다.");
        return;
      }
      setChecked((data) => [...data, id]);
    }
  };

  const onSubmit = () => {
    setFormData((data) => ({
      ...data,
      cmpnyBadge: checked,
      cmpnyBadgeText: checked.map((check) => badges[check]),
    }));

    setModal("");
  };

  return (
    <Modal onClick={(e) => e.target === e.currentTarget && setModal("")}>
      <BadgesModalContainer className="modal">
        <strong className="label">혜택 목록</strong>
        <div className="badges">
          {badges && Object.keys(badges).length > 0 ? (
            Object.entries(badges).map(([id, name]) => (
              <span
                key={id}
                className={checked.includes(Number(id)) ? "active" : "inactive"}
                onClick={() => toggleCheck(Number(id))}>
                {name}
              </span>
            ))
          ) : (
            <span>혜택이 존재하지 않습니다.</span>
          )}
        </div>
        <button className="submit" onClick={() => onSubmit()}>
          저장
        </button>
        <button className="closeModal" onClick={() => setModal("")}>
          <IoClose />
        </button>
      </BadgesModalContainer>
    </Modal>
  );
};

export default BadgesModal;
